'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _CallHandler = require('../../../CallHandler');

var _CallHandler2 = _interopRequireDefault(_CallHandler);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _RoomViewStore = require('../../../stores/RoomViewStore');

var _RoomViewStore2 = _interopRequireDefault(_RoomViewStore);

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _Stickerpicker = require('./Stickerpicker');

var _Stickerpicker2 = _interopRequireDefault(_Stickerpicker);

var _matrixTo = require('../../../matrix-to');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _E2EIcon = require('./E2EIcon');

var _E2EIcon2 = _interopRequireDefault(_E2EIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017, 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
var formatButtonList = [(0, _languageHandler._td)("bold"), (0, _languageHandler._td)("italic"), (0, _languageHandler._td)("deleted"), (0, _languageHandler._td)("underlined"), (0, _languageHandler._td)("inline-code"), (0, _languageHandler._td)("block-quote"), (0, _languageHandler._td)("bulleted-list"), (0, _languageHandler._td)("numbered-list")];

var MessageComposer = function (_React$Component) {
    (0, _inherits3.default)(MessageComposer, _React$Component);

    function MessageComposer(props, context) {
        (0, _classCallCheck3.default)(this, MessageComposer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageComposer.__proto__ || (0, _getPrototypeOf2.default)(MessageComposer)).call(this, props, context));

        _this.onCallClick = _this.onCallClick.bind(_this);
        _this.onHangupClick = _this.onHangupClick.bind(_this);
        _this.onUploadClick = _this.onUploadClick.bind(_this);
        _this.onUploadFileSelected = _this.onUploadFileSelected.bind(_this);
        _this.uploadFiles = _this.uploadFiles.bind(_this);
        _this.onVoiceCallClick = _this.onVoiceCallClick.bind(_this);
        _this._onAutocompleteConfirm = _this._onAutocompleteConfirm.bind(_this);
        _this.onToggleFormattingClicked = _this.onToggleFormattingClicked.bind(_this);
        _this.onToggleMarkdownClicked = _this.onToggleMarkdownClicked.bind(_this);
        _this.onInputStateChanged = _this.onInputStateChanged.bind(_this);
        _this.onEvent = _this.onEvent.bind(_this);
        _this._onRoomStateEvents = _this._onRoomStateEvents.bind(_this);
        _this._onRoomViewStoreUpdate = _this._onRoomViewStoreUpdate.bind(_this);
        _this._onTombstoneClick = _this._onTombstoneClick.bind(_this);

        _this.state = {
            inputState: {
                marks: [],
                blockType: null,
                isRichTextEnabled: _SettingsStore2.default.getValue('MessageComposerInput.isRichTextEnabled')
            },
            showFormatting: _SettingsStore2.default.getValue('MessageComposer.showFormatting'),
            isQuoting: Boolean(_RoomViewStore2.default.getQuotingEvent()),
            tombstone: _this._getRoomTombstone()
        };
        return _this;
    }

    (0, _createClass3.default)(MessageComposer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // N.B. using 'event' rather than 'RoomEvents' otherwise the crypto handler
            // for 'event' fires *after* 'RoomEvent', and our room won't have yet been
            // marked as encrypted.
            // XXX: fragile as all hell - fixme somehow, perhaps with a dedicated Room.encryption event or something.
            _MatrixClientPeg2.default.get().on("event", this.onEvent);
            _MatrixClientPeg2.default.get().on("RoomState.events", this._onRoomStateEvents);
            this._roomStoreToken = _RoomViewStore2.default.addListener(this._onRoomViewStoreUpdate);
            this._waitForOwnMember();
        }
    }, {
        key: '_waitForOwnMember',
        value: function _waitForOwnMember() {
            var _this2 = this;

            // if we have the member already, do that
            var me = this.props.room.getMember(_MatrixClientPeg2.default.get().getUserId());
            if (me) {
                this.setState({ me: me });
                return;
            }
            // Otherwise, wait for member loading to finish and then update the member for the avatar.
            // The members should already be loading, and loadMembersIfNeeded
            // will return the promise for the existing operation
            this.props.room.loadMembersIfNeeded().then(function () {
                var me = _this2.props.room.getMember(_MatrixClientPeg2.default.get().getUserId());
                _this2.setState({ me: me });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (_MatrixClientPeg2.default.get()) {
                _MatrixClientPeg2.default.get().removeListener("event", this.onEvent);
                _MatrixClientPeg2.default.get().removeListener("RoomState.events", this._onRoomStateEvents);
            }
            if (this._roomStoreToken) {
                this._roomStoreToken.remove();
            }
        }
    }, {
        key: 'onEvent',
        value: function onEvent(event) {
            if (event.getType() !== 'm.room.encryption') return;
            if (event.getRoomId() !== this.props.room.roomId) return;
            this.forceUpdate();
        }
    }, {
        key: '_onRoomStateEvents',
        value: function _onRoomStateEvents(ev, state) {
            if (ev.getRoomId() !== this.props.room.roomId) return;

            if (ev.getType() === 'm.room.tombstone') {
                this.setState({ tombstone: this._getRoomTombstone() });
            }
        }
    }, {
        key: '_getRoomTombstone',
        value: function _getRoomTombstone() {
            return this.props.room.currentState.getStateEvents('m.room.tombstone', '');
        }
    }, {
        key: '_onRoomViewStoreUpdate',
        value: function _onRoomViewStoreUpdate() {
            var isQuoting = Boolean(_RoomViewStore2.default.getQuotingEvent());
            if (this.state.isQuoting === isQuoting) return;
            this.setState({ isQuoting: isQuoting });
        }
    }, {
        key: 'onUploadClick',
        value: function onUploadClick(ev) {
            if (_MatrixClientPeg2.default.get().isGuest()) {
                _dispatcher2.default.dispatch({ action: 'require_registration' });
                return;
            }

            this.refs.uploadInput.click();
        }
    }, {
        key: 'onUploadFileSelected',
        value: function onUploadFileSelected(files) {
            var tfiles = files.target.files;
            this.uploadFiles(tfiles);
        }
    }, {
        key: 'uploadFiles',
        value: function uploadFiles(files) {
            var _this3 = this;

            var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
            var TintableSvg = _index2.default.getComponent("elements.TintableSvg");

            var fileList = [];
            var acceptedFiles = [];
            var failedFiles = [];

            for (var i = 0; i < files.length; i++) {
                var fileAcceptedOrError = this.props.uploadAllowed(files[i]);
                if (fileAcceptedOrError === true) {
                    acceptedFiles.push(_react2.default.createElement(
                        'li',
                        { key: i },
                        _react2.default.createElement(TintableSvg, { key: i, src: require("../../../../res/img/files.svg"), width: '16', height: '16' }),
                        ' ',
                        files[i].name || (0, _languageHandler._t)('Attachment')
                    ));
                    fileList.push(files[i]);
                } else {
                    failedFiles.push(_react2.default.createElement(
                        'li',
                        { key: i },
                        _react2.default.createElement(TintableSvg, { key: i, src: require("../../../../res/img/files.svg"), width: '16', height: '16' }),
                        ' ',
                        files[i].name || (0, _languageHandler._t)('Attachment'),
                        ' ',
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)('Reason') + ": " + fileAcceptedOrError
                        )
                    ));
                }
            }

            var isQuoting = Boolean(_RoomViewStore2.default.getQuotingEvent());
            var replyToWarning = null;
            if (isQuoting) {
                replyToWarning = _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)('At this time it is not possible to reply with a file so this will be sent without being a reply.')
                );
            }

            var acceptedFilesPart = acceptedFiles.length === 0 ? null : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)('Are you sure you want to upload the following files?')
                ),
                _react2.default.createElement(
                    'ul',
                    { style: { listStyle: 'none', textAlign: 'left' } },
                    acceptedFiles
                )
            );

            var failedFilesPart = failedFiles.length === 0 ? null : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)('The following files cannot be uploaded:')
                ),
                _react2.default.createElement(
                    'ul',
                    { style: { listStyle: 'none', textAlign: 'left' } },
                    failedFiles
                )
            );
            var buttonText = void 0;
            if (acceptedFiles.length > 0 && failedFiles.length > 0) {
                buttonText = "Upload selected";
            } else if (failedFiles.length > 0) {
                buttonText = "Close";
            }

            _Modal2.default.createTrackedDialog('Upload Files confirmation', '', QuestionDialog, {
                title: (0, _languageHandler._t)('Upload Files'),
                description: _react2.default.createElement(
                    'div',
                    null,
                    acceptedFilesPart,
                    failedFilesPart,
                    replyToWarning
                ),
                hasCancelButton: acceptedFiles.length > 0,
                button: buttonText,
                onFinished: function onFinished(shouldUpload) {
                    if (shouldUpload) {
                        // MessageComposer shouldn't have to rely on its parent passing in a callback to upload a file
                        if (fileList) {
                            for (var _i = 0; _i < fileList.length; _i++) {
                                _this3.props.uploadFile(fileList[_i]);
                            }
                        }
                    }

                    _this3.refs.uploadInput.value = null;
                }
            });
        }
    }, {
        key: 'onHangupClick',
        value: function onHangupClick() {
            var call = _CallHandler2.default.getCallForRoom(this.props.room.roomId);
            //var call = CallHandler.getAnyActiveCall();
            if (!call) {
                return;
            }
            _dispatcher2.default.dispatch({
                action: 'hangup',
                // hangup the call for this room, which may not be the room in props
                // (e.g. conferences which will hangup the 1:1 room instead)
                room_id: call.roomId
            });
        }
    }, {
        key: 'onCallClick',
        value: function onCallClick(ev) {
            _dispatcher2.default.dispatch({
                action: 'place_call',
                type: ev.shiftKey ? "screensharing" : "video",
                room_id: this.props.room.roomId
            });
        }
    }, {
        key: 'onVoiceCallClick',
        value: function onVoiceCallClick(ev) {
            _dispatcher2.default.dispatch({
                action: 'place_call',
                type: "voice",
                room_id: this.props.room.roomId
            });
        }
    }, {
        key: 'onInputStateChanged',
        value: function onInputStateChanged(inputState) {
            this.setState({ inputState: inputState });
        }
    }, {
        key: '_onAutocompleteConfirm',
        value: function _onAutocompleteConfirm(range, completion) {
            if (this.messageComposerInput) {
                this.messageComposerInput.setDisplayedCompletion(range, completion);
            }
        }
    }, {
        key: 'onFormatButtonClicked',
        value: function onFormatButtonClicked(name, event) {
            event.preventDefault();
            this.messageComposerInput.onFormatButtonClicked(name, event);
        }
    }, {
        key: 'onToggleFormattingClicked',
        value: function onToggleFormattingClicked() {
            _SettingsStore2.default.setValue("MessageComposer.showFormatting", null, _SettingsStore.SettingLevel.DEVICE, !this.state.showFormatting);
            this.setState({ showFormatting: !this.state.showFormatting });
        }
    }, {
        key: 'onToggleMarkdownClicked',
        value: function onToggleMarkdownClicked(e) {
            e.preventDefault(); // don't steal focus from the editor!
            this.messageComposerInput.enableRichtext(!this.state.inputState.isRichTextEnabled);
        }
    }, {
        key: '_onTombstoneClick',
        value: function _onTombstoneClick(ev) {
            ev.preventDefault();

            var replacementRoomId = this.state.tombstone.getContent()['replacement_room'];
            var replacementRoom = _MatrixClientPeg2.default.get().getRoom(replacementRoomId);
            var createEventId = null;
            if (replacementRoom) {
                var createEvent = replacementRoom.currentState.getStateEvents('m.room.create', '');
                if (createEvent && createEvent.getId()) createEventId = createEvent.getId();
            }
            _dispatcher2.default.dispatch({
                action: 'view_room',
                highlighted: true,
                event_id: createEventId,
                room_id: replacementRoomId,

                // Try to join via the server that sent the event. This converts $something:example.org
                // into a server domain by splitting on colons and ignoring the first entry ("$something").
                via_servers: [this.state.tombstone.getId().split(':').splice(1).join(':')]
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var uploadInputStyle = { display: 'none' };
            var MemberStatusMessageAvatar = _index2.default.getComponent('avatars.MemberStatusMessageAvatar');
            var MessageComposerInput = _index2.default.getComponent("rooms.MessageComposerInput");

            var controls = [];

            if (this.state.me) {
                controls.push(_react2.default.createElement(
                    'div',
                    { key: 'controls_avatar', className: 'mx_MessageComposer_avatar' },
                    _react2.default.createElement(MemberStatusMessageAvatar, { member: this.state.me, width: 24, height: 24 })
                ));
            }

            if (this.props.e2eStatus) {
                controls.push(_react2.default.createElement(_E2EIcon2.default, {
                    status: this.props.e2eStatus,
                    key: 'e2eIcon',
                    className: 'mx_MessageComposer_e2eIcon' }));
            }

            var callButton = void 0;
            var videoCallButton = void 0;
            var hangupButton = void 0;

            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            // Call buttons
            if (this.props.callState && this.props.callState !== 'ended') {
                hangupButton = _react2.default.createElement(AccessibleButton, { className: 'mx_MessageComposer_button mx_MessageComposer_hangup',
                    key: 'controls_hangup',
                    onClick: this.onHangupClick,
                    title: (0, _languageHandler._t)('Hangup')
                });
            } else {
                callButton = _react2.default.createElement(AccessibleButton, { className: 'mx_MessageComposer_button mx_MessageComposer_voicecall',
                    key: 'controls_call',
                    onClick: this.onVoiceCallClick,
                    title: (0, _languageHandler._t)('Voice call')
                });
                videoCallButton = _react2.default.createElement(AccessibleButton, { className: 'mx_MessageComposer_button mx_MessageComposer_videocall',
                    key: 'controls_videocall',
                    onClick: this.onCallClick,
                    title: (0, _languageHandler._t)('Video call')
                });
            }

            var canSendMessages = !this.state.tombstone && this.props.room.maySendMessage();

            // TODO: Remove temporary logging for riot-web#7838
            // Note: we rip apart the power level event ourselves because we don't want to
            // log too much data about it - just the bits we care about. Many of the variables
            // logged here are to help figure out where in the stack the 'cannot post in room'
            // warning is coming from. This means logging various numbers from the PL event to
            // verify RoomState._maySendEventOfType is doing the right thing.
            var room = this.props.room;
            var plEvent = room.currentState.getStateEvents('m.room.power_levels', '');
            var plEventString = "<no power level event>";
            if (plEvent) {
                var content = plEvent.getContent();
                if (!content) {
                    plEventString = "<no event content>";
                } else {
                    var stringifyFalsey = function stringifyFalsey(v) {
                        return v === null ? '<null>' : v === undefined ? '<undefined>' : v;
                    };
                    var actualUserPl = stringifyFalsey(content.users ? content.users[room.myUserId] : "<no users in content>");
                    var usersPl = stringifyFalsey(content.users_default);
                    var actualEventPl = stringifyFalsey(content.events ? content.events['m.room.message'] : "<no events in content>");
                    var eventPl = stringifyFalsey(content.events_default);
                    plEventString = 'actualUserPl=' + actualUserPl + ' defaultUserPl=' + usersPl + ' actualEventPl=' + actualEventPl + ' defaultEventPl=' + eventPl;
                }
            }
            console.log('[riot-web#7838] renderComposer() hasTombstone=' + !!this.state.tombstone + ' maySendMessage=' + room.maySendMessage() + (' myMembership=' + room.getMyMembership() + ' maySendEvent=' + room.currentState.maySendEvent('m.room.message', room.myUserId)) + (' myUserId=' + room.myUserId + ' roomId=' + room.roomId + ' hasPlEvent=' + !!plEvent + ' powerLevels=\'' + plEventString + '\''));

            if (canSendMessages) {
                // This also currently includes the call buttons. Really we should
                // check separately for whether we can call, but this is slightly
                // complex because of conference calls.
                var uploadButton = _react2.default.createElement(
                    AccessibleButton,
                    { className: 'mx_MessageComposer_button mx_MessageComposer_upload',
                        key: 'controls_upload',
                        onClick: this.onUploadClick,
                        title: (0, _languageHandler._t)('Upload file')
                    },
                    _react2.default.createElement('input', { ref: 'uploadInput', type: 'file',
                        style: uploadInputStyle,
                        multiple: true,
                        onChange: this.onUploadFileSelected })
                );

                var formattingButton = this.state.inputState.isRichTextEnabled ? _react2.default.createElement(AccessibleButton, { element: 'img', className: 'mx_MessageComposer_formatting',
                    alt: (0, _languageHandler._t)("Show Text Formatting Toolbar"),
                    title: (0, _languageHandler._t)("Show Text Formatting Toolbar"),
                    src: require("../../../../res/img/button-text-formatting.svg"),
                    onClick: this.onToggleFormattingClicked,
                    style: { visibility: this.state.showFormatting ? 'hidden' : 'visible' },
                    key: 'controls_formatting' }) : null;

                var roomIsEncrypted = _MatrixClientPeg2.default.get().isRoomEncrypted(this.props.room.roomId);
                var placeholderText = void 0;
                if (this.state.isQuoting) {
                    if (roomIsEncrypted) {
                        placeholderText = (0, _languageHandler._t)('Send an encrypted reply…');
                    } else {
                        placeholderText = (0, _languageHandler._t)('Send a reply (unencrypted)…');
                    }
                } else {
                    if (roomIsEncrypted) {
                        placeholderText = (0, _languageHandler._t)('Send an encrypted message…');
                    } else {
                        placeholderText = (0, _languageHandler._t)('Send a message (unencrypted)…');
                    }
                }

                var stickerpickerButton = _react2.default.createElement(_Stickerpicker2.default, { key: 'stickerpicker_controls_button', room: this.props.room });

                controls.push(_react2.default.createElement(MessageComposerInput, {
                    ref: function ref(c) {
                        return _this4.messageComposerInput = c;
                    },
                    key: 'controls_input',
                    onResize: this.props.onResize,
                    room: this.props.room,
                    placeholder: placeholderText,
                    onFilesPasted: this.uploadFiles,
                    onInputStateChanged: this.onInputStateChanged }), formattingButton, stickerpickerButton, uploadButton, hangupButton, callButton, videoCallButton);
            } else if (this.state.tombstone) {
                var replacementRoomId = this.state.tombstone.getContent()['replacement_room'];

                controls.push(_react2.default.createElement(
                    'div',
                    { className: 'mx_MessageComposer_replaced_wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_MessageComposer_replaced_valign' },
                        _react2.default.createElement('img', { className: 'mx_MessageComposer_roomReplaced_icon', src: require("../../../../res/img/room_replaced.svg") }),
                        _react2.default.createElement(
                            'span',
                            { className: 'mx_MessageComposer_roomReplaced_header' },
                            (0, _languageHandler._t)("This room has been replaced and is no longer active.")
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'a',
                            { href: (0, _matrixTo.makeRoomPermalink)(replacementRoomId),
                                className: 'mx_MessageComposer_roomReplaced_link',
                                onClick: this._onTombstoneClick
                            },
                            (0, _languageHandler._t)("The conversation continues here.")
                        )
                    )
                ));
            } else {
                // TODO: Remove temporary logging for riot-web#7838
                console.log("[riot-web#7838] Falling back to showing cannot post in room error");
                controls.push(_react2.default.createElement(
                    'div',
                    { key: 'controls_error', className: 'mx_MessageComposer_noperm_error' },
                    (0, _languageHandler._t)('You do not have permission to post to this room')
                ));
            }

            var formatBar = void 0;
            if (this.state.showFormatting && this.state.inputState.isRichTextEnabled) {
                var _state$inputState = this.state.inputState,
                    marks = _state$inputState.marks,
                    blockType = _state$inputState.blockType;

                var formatButtons = formatButtonList.map(function (name) {
                    // special-case to match the md serializer and the special-case in MessageComposerInput.js
                    var markName = name === 'inline-code' ? 'code' : name;
                    var active = marks.some(function (mark) {
                        return mark.type === markName;
                    }) || blockType === name;
                    var suffix = active ? '-on' : '';
                    var onFormatButtonClicked = _this4.onFormatButtonClicked.bind(_this4, name);
                    var className = 'mx_MessageComposer_format_button mx_filterFlipColor';
                    return _react2.default.createElement('img', { className: className,
                        title: (0, _languageHandler._t)(name),
                        onMouseDown: onFormatButtonClicked,
                        key: name,
                        src: require('../../../../res/img/button-text-' + name + suffix + '.svg'),
                        height: '17' });
                });

                formatBar = _react2.default.createElement(
                    'div',
                    { className: 'mx_MessageComposer_formatbar_wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_MessageComposer_formatbar' },
                        formatButtons,
                        _react2.default.createElement('div', { style: { flex: 1 } }),
                        _react2.default.createElement('img', { title: this.state.inputState.isRichTextEnabled ? (0, _languageHandler._t)("Turn Markdown on") : (0, _languageHandler._t)("Turn Markdown off"),
                            onMouseDown: this.onToggleMarkdownClicked,
                            className: 'mx_MessageComposer_formatbar_markdown mx_filterFlipColor',
                            src: require('../../../../res/img/button-md-' + !this.state.inputState.isRichTextEnabled + '.png') }),
                        _react2.default.createElement(AccessibleButton, { element: 'img', title: (0, _languageHandler._t)("Hide Text Formatting Toolbar"),
                            onClick: this.onToggleFormattingClicked,
                            className: 'mx_MessageComposer_formatbar_cancel mx_filterFlipColor',
                            src: require("../../../../res/img/icon-text-cancel.svg") })
                    )
                );
            }

            var wrapperClasses = (0, _classnames2.default)({
                mx_MessageComposer_wrapper: true,
                mx_MessageComposer_hasE2EIcon: !!this.props.e2eStatus
            });
            return _react2.default.createElement(
                'div',
                { className: 'mx_MessageComposer' },
                _react2.default.createElement(
                    'div',
                    { className: wrapperClasses },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_MessageComposer_row' },
                        controls
                    )
                ),
                formatBar
            );
        }
    }]);
    return MessageComposer;
}(_react2.default.Component);

exports.default = MessageComposer;


MessageComposer.propTypes = {
    // a callback which is called when the height of the composer is
    // changed due to a change in content.
    onResize: _propTypes2.default.func,

    // js-sdk Room object
    room: _propTypes2.default.object.isRequired,

    // string representing the current voip call state
    callState: _propTypes2.default.string,

    // callback when a file to upload is chosen
    uploadFile: _propTypes2.default.func.isRequired,

    // function to test whether a file should be allowed to be uploaded.
    uploadAllowed: _propTypes2.default.func.isRequired,

    // string representing the current room app drawer state
    showApps: _propTypes2.default.bool
};
module.exports = exports['default'];
//# sourceMappingURL=MessageComposer.js.map